import { render, staticRenderFns } from "./terminos.vue?vue&type=template&id=9331e99c&scoped=true&"
import script from "./terminos.vue?vue&type=script&lang=js&"
export * from "./terminos.vue?vue&type=script&lang=js&"
import style0 from "./terminos.vue?vue&type=style&index=0&id=9331e99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9331e99c",
  null
  
)

export default component.exports